var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-container"},[_c('vue-apex-charts',{ref:"chart",attrs:{"type":"donut","height":"350","options":_vm.resumoSinaisChartOptions,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }